<template>
  <div class="about">
    <div
      class="container-fluid"
      style="background:var(--accent);text-align:center;"
    >
      <img src="../assets/webLogoBlanco.svg" alt="" style="height:100px;" />
    </div>
    <acercaDe />
    <tabs />
  </div>
</template>
<script>
import acercaDe from "../components/AboutUs/acercaDe";
import tabs from "../components/AboutUs/tabs";
export default {
  components: {
    acercaDe,
    tabs,
  },
  created() {
    document.title = "OverLab | Conózcanos";
  },
};
</script>

<style lang="css" scoped>
.about {
  margin-top: 100px;
}
@media (max-width: 995px) {
  .about {
    margin-top: 0;
  }
}
</style>
